module.exports = __webpack_public_path__ + "e2c6669d49f79a1e78fcc0816adb023d.wav";